import { Box, Typography } from '@mui/material';
import { PieceHeading } from './PieceHeading';
import {
  HERO_PANEL_BG,
  HERO_PANEL_BORDER,
  HERO_BAR_COLORS,
  HERO_TEXT_SECONDARY,
  HERO_TEXT_EYEBROW,
  HERO_FONT_MONO,
} from '../designTokens';

const ROWS = [
  { name: 'Alex Chen',    bars: [{ s: 6,  w: 28, c: 0 }, { s: 38, w: 18, c: 3 }] },
  { name: 'Priya Patel',  bars: [{ s: 0,  w: 22, c: 1 }, { s: 24, w: 36, c: 2 }] },
  { name: 'Jordan Kim',   bars: [{ s: 12, w: 44, c: 4 }] },
  { name: 'Sam Williams', bars: [{ s: 0,  w: 16, c: 5 }, { s: 20, w: 22, c: 0 }, { s: 46, w: 14, c: 6 }] },
  { name: 'Lina Ortiz',   bars: [{ s: 8,  w: 30, c: 2 }] },
];
const DAYS = ['M', 'T', 'W', 'T', 'F'];

export function PieceGantt() {
  return (
    <Box sx={{ maxWidth: 520, display: 'flex', flexDirection: 'column', gap: 3 }}>
      <PieceHeading eyebrow="Plan delivery, week by week" line1="Know who's free." line2="Know what's next." />
      <Box
        sx={{
          background: HERO_PANEL_BG,
          border: `1px solid ${HERO_PANEL_BORDER}`,
          borderRadius: '12px',
          p: '14px 16px',
        }}
      >
        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: '88px 1fr',
            alignItems: 'center',
            mb: 1,
            fontSize: '0.625rem',
            color: HERO_TEXT_EYEBROW,
            fontFamily: HERO_FONT_MONO,
            letterSpacing: '0.08em',
            textTransform: 'uppercase',
          }}
        >
          <span>Week 22</span>
          <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(5, 1fr)', gap: 0.5 }}>
            {DAYS.map((d, i) => (
              <Box key={i} component="span" sx={{ textAlign: 'center', fontSize: 'inherit' }}>
                {d}
              </Box>
            ))}
          </Box>
        </Box>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.75 }}>
          {ROWS.map((r) => (
            <Box
              key={r.name}
              sx={{
                display: 'grid',
                gridTemplateColumns: '88px 1fr',
                alignItems: 'center',
                fontSize: '0.71875rem',
                color: HERO_TEXT_SECONDARY,
              }}
            >
              <Typography
                component="span"
                sx={{ overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis', fontSize: 'inherit', color: 'inherit' }}
              >
                {r.name}
              </Typography>
              <Box sx={{ position: 'relative', height: 18, borderRadius: '4px', background: HERO_PANEL_BG }}>
                {r.bars.map((b, j) => (
                  <Box
                    key={j}
                    aria-hidden
                    sx={{
                      position: 'absolute',
                      left: `${b.s}%`,
                      width: `${b.w}%`,
                      top: 2,
                      bottom: 2,
                      background: HERO_BAR_COLORS[b.c],
                      borderRadius: '4px',
                    }}
                  />
                ))}
              </Box>
            </Box>
          ))}
        </Box>
      </Box>
    </Box>
  );
}
